import { gql } from '@apollo/client'

export default gql`
  mutation ClaimDailyCheckIn($input: ClaimDailyCheckInInput!) {
    claimDailyCheckIn(input: $input) {
      campaignID
      cycle
      day
      bonusHash
      isClaimedSuccess
    }
  }
`
